import {
  Chart as ChartJS,
  LineController,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  TimeScale,
  LineElement,
  Colors,
} from 'chart.js';
import 'chartjs-adapter-date-fns';

ChartJS.register(
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  TimeScale,
  Colors
);
